<div id="main-content">
  <!-- * MAIN CONTENT -->
  <div class="content">
    <!-- * TOP HEADER -->
    <!-- <app-navbar></app-navbar> -->
    <section
      class="flex flex-column justify-content-between"
      style="height: 91vh"
    >
      <div class="client-content container">
        <router-outlet></router-outlet>
      </div>
      <!-- <app-footer></app-footer> -->
    </section>
  </div>
</div>
